/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WsPing
 */
export interface WsPing {
    /**
     * Type of the message
     * @type {string}
     * @memberof WsPing
     */
    type?: string | null;
}

/**
 * Check if a given object implements the WsPing interface.
 */
export function instanceOfWsPing(value: object): value is WsPing {
    return true;
}

export function WsPingFromJSON(json: any): WsPing {
    return WsPingFromJSONTyped(json, false);
}

export function WsPingFromJSONTyped(json: any, ignoreDiscriminator: boolean): WsPing {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function WsPingToJSON(json: any): WsPing {
    return WsPingToJSONTyped(json, false);
}

export function WsPingToJSONTyped(value?: WsPing | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
    };
}

